import React, { Component } from 'react';
import { submit, isSubmitting } from 'redux-form';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import {
  StyledHeader,
  StyledMain,
  StyledHeaderContainer,
  StyledAddButton,
  StyledTableContainer,
} from 'helpers/StyledTableComponentsHelper';

import ParcelDetailsDialogWithTenantDetails from 'components/shared/ParcelDetailsDialog/ParcelDetailsDialogWithTenantDetails';
import AddParcelForm from './AddParcelForm';

import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';
import { ParcelStatus } from 'components/shared/StatusHelper';
import { toFriendlyDateString } from 'helpers/Formatter';

import FlatButton from 'material-ui/FlatButton';

import Toggle from 'material-ui/Toggle';

import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import HeaderWithPeriod from 'components/shared/HeaderWithPeriod';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import * as landlordPropertiesActions from 'actions/landlordPropertiesActions';
import * as landlordParcelsActions from 'actions/landlordParcelsActions';
import TableFilters from 'components/ui/TableFilters';
import TabbedTable from 'components/ui/TabbedTable';
import MobileTable from 'components/ui/MobileTable';

const statuses = ['pending_pickup', 'released'];

export default withMobileDialog()(
  connect(
    store => ({
      parcels: store.landlordParcels.parcels,
      signature: store.landlordParcels.signature,
      properties: store.landlordProperties.properties,
      submitting: isSubmitting('add_parcel')(store),
      fetchingParcels: store.landlordParcels.fetchingParcels,
      parcelsCounts: store.landlordParcels.parcelsCounts,
    }),
    {
      ...landlordPropertiesActions,
      submit,
      ...landlordParcelsActions,
    }
  )(
    class LandlordParcels extends Component {
      constructor(props) {
        super(props);
        this.state = {
          showAllParcels: false,
          parcelIsOpen: false,
          showParcelDetails: false,
          allowParcelSubmit: false,
          newParcelUID: null,
          showFilters: true,
          filtersActive: false,
          filters: {
            search: '',
            properties: Array(this.props.properties.length).fill(false),
            statuses: Array(statuses.length).fill(false),
          },
          currentTab: 'pending_pickup',
          sortKey: '',
          sortOrder: '',
          offset: 0,
        };
      }

      setRef = ref => (this.table = ref);

      fetchParcelsAndStats = () => {
        this.props.getParcelStats();
        this.fetchParcels();
      };

      componentDidMount = () => {
        this.fetchParcelsAndStats();
        this.props.getProperties({ for_multiselect: true });
      };

      filterProperties = booleanArrayMask => {
        return this.props.properties.filter((_, i) => booleanArrayMask[i]);
      };

      filterStatuses = booleanArrayMask => {
        return statuses.filter((_, i) => booleanArrayMask[i]);
      };

      handleClearSearch = setFieldValue => {
        this.setState(
          {
            filtersActive: false,
            filters: {
              search: '',
              properties: Array(this.props.properties.length).fill(false),
              statuses: Array(statuses.length).fill(false),
            },
            offset: 0,
          },
          () => this.fetchParcels()
        );

        if (this.table) this.table.scrollToTop(0);
        setFieldValue('search', '');
        setFieldValue('properties', Array(this.props.properties.length).fill(false));
        setFieldValue('statuses', Array(statuses.length).fill(false));
      };

      handleFilters = values => {
        const isFiltersUntouched =
          values.search === '' &&
          !values.properties.includes(true) &&
          !values.statuses.includes(true);
        const newState = {
          filtersActive: !isFiltersUntouched,
          filters: {
            search: values.search,
            properties: values.properties,
            statuses: values.statuses,
          },
          drawerVisible: false,
          offset: 0,
        };

        this.setState(newState, () => this.fetchParcels());
        if (this.table) this.table.scrollToTop(0);
      };

      columns = [
        {
          title: 'Status',
          dataKey: 'status',
          sortable: false,
          width: 200,
          render: ({ rowData }) => (
            <ParcelStatus
              hasMultiple={
                this.props.parcels.filter(
                  parcelDetails =>
                    parcelDetails.tenant_full_name === rowData.tenant_full_name &&
                    !parcelDetails.released_at
                ).length > 1
              }
              parcelDetails={rowData}
            />
          ),
        },
        {
          title: 'Full Name',
          dataKey: 'recipient_full_name',
          sortable: true,
          width: 300,
        },
        {
          title: 'Unit',
          dataKey: 'unit_number',
          sortable: true,
          width: 150,
        },
        {
          title: 'UUID',
          dataKey: 'uuid',
          sortable: true,
          width: 175,
        },
        {
          title: 'Received On',
          dataKey: 'received_at',
          sortable: true,
          width: 200,
          render: ({ data }) => toFriendlyDateString(data),
        },
        {
          title: 'Picked up on',
          dataKey: 'released_at',
          sortable: true,
          width: 200,
          render: ({ data }) => toFriendlyDateString(data),
        },
      ];

      handleTabChange = (tabName, _queryObj) => {
        this.setState(
          {
            currentTab: tabName,
            offset: 0,
          },
          () => {
            this.fetchParcels();
          }
        );
        if (this.table) this.table.scrollToTop(0);
      };

      handleSort = (key, order) => {
        this.setState(
          {
            sortKey: key,
            sortOrder: order,
            offset: 0,
          },
          () => {
            this.fetchParcels();
          }
        );
        if (this.table) this.table.scrollToTop(0);
      };

      fetchParcels = () => {
        const { filters, filtersActive, currentTab, offset, sortKey, sortOrder } = this.state;

        let fetchPromise = null;

        let filterOptions = {
          sort_key: sortKey,
          sort_order: sortOrder,
        };

        if (filtersActive) {
          const propertiesToFilter = this.filterProperties(filters.properties).map(
            data => data.value
          );
          const statusesToFilter = this.filterStatuses(filters.statuses);

          filterOptions = {
            query: filters.search,
            property_ids: propertiesToFilter,
            statuses: statusesToFilter,
            sort_key: sortKey,
            sort_order: sortOrder,
          };

          fetchPromise = this.props.getFilteredParcels('all', offset, filterOptions);
        } else {
          fetchPromise = this.props.getFilteredParcels(currentTab, offset, filterOptions);
        }

        fetchPromise.then(() => {
          this.setState({
            offset: this.props.parcels.length,
          });
        });
      };

      accentColor = AccentColor();

      toggleParcelDialog = () => {
        if (!this.state.parcelIsOpen) {
          this.props.getUniqueParcelUID().then(response => {
            this.setState({ newParcelUID: response.value.unique_parcel_uid, parcelIsOpen: true });
          });

          return;
        }

        this.setState(prevState => ({
          newParcelUID: null,
          parcelIsOpen: false,
        }));
      };

      toggleParcelDetailsDialog = parcelDetails => {
        this.setState(prevState => ({
          parcelIsOpen: !prevState.parcelIsOpen,
          parcelDetails,
        }));
      };

      addParcel = async formData => {
        formData['parcel_uid'] = this.state.newParcelUID;
        await this.props.createOrUpdateParcel(formData);
        this.toggleParcelDialog();
        this.setState(
          {
            offset: 0,
          },
          () => {
            this.fetchParcelsAndStats();
          }
        );
      };

      toggleParcelDetailsDialog = () => {
        this.setState(prevState => ({ showParcelDetails: !prevState.showParcelDetails }));
      };

      openParcelDetails = parcelID => {
        this.props.getParcelDetails(parcelID).then(() => {
          this.toggleParcelDetailsDialog();
        });
      };

      allowParcelSubmit = allowSubmit => {
        this.setState({ allowParcelSubmit: allowSubmit });
      };

      onSignatureEnd = image => {
        this.props.saveSignature(image);
      };

      releaseParcels = parcelIds => {
        this.props.releaseParcels(this.props.signature, parcelIds).then(() => {
          this.toggleParcelDetailsDialog();
          this.setState(
            {
              offset: 0,
            },
            () => {
              this.fetchParcelsAndStats();
            }
          );
        });
      };

      render() {
        const { filters } = this.state;
        const { parcels, parcelsCounts } = this.props;

        const filterOptions = [
          {
            useSearch: true,
            options: this.props.properties.map(data => data.label),
            name: 'properties',
            title: 'Select properties to filter by',
          },
          {
            useSearch: false,
            options: statuses,
            name: 'statuses',
            title: 'Filter by application status',
          },
        ];

        const tabs = [
          {
            title: 'Pending Pickup',
            label: 'Pending Pickup',
            value: 'pending_pickup',
            count: parcelsCounts['pending_pickup'] || 0,
            onClick: () =>
              this.handleTabChange('pending_pickup', {
                subset: 'pending_pickup',
              }),
          },
          {
            title: 'Picked Up',
            label: 'Picked Up',
            value: 'picked_up',
            count: parcelsCounts['picked_up'] || 0,
            onClick: () =>
              this.handleTabChange('picked_up', {
                subset: 'picked_up',
              }),
          },
          {
            title: 'All',
            label: 'All',
            value: 'all',
            count: parcelsCounts['all'] || 0,
            onClick: () => this.handleTabChange('all', { subset: 'all' }),
          },
        ];

        return (
          <StyledMain>
            <StyledHeaderContainer>
              <StyledHeader>
                <HeaderWithPeriod headerText={<span>Parcels</span>} newStyle />
                <StyledAddButton accentColor={this.accentColor} onClick={this.toggleParcelDialog}>
                  Add Parcel
                </StyledAddButton>
              </StyledHeader>
              <TableFilters
                filters={filters}
                handleSubmitFilters={this.handleFilters}
                handleClearFilters={this.handleClearSearch}
                filterOptions={filterOptions}
                accentColor={this.accentColor}
              />
            </StyledHeaderContainer>

            <StyledTableContainer>
              {this._renderTableView({ parcels, tabs })}
              {this._renderMobileView({
                parcels,
                tabs,
                currentTab: this.state.currentTab,
                tabChange: this.handleTabChange,
              })}
            </StyledTableContainer>

            <ParcelDetailsDialogWithTenantDetails
              isOpen={this.state.showParcelDetails}
              toggleParcelDetailsDialog={this.toggleParcelDetailsDialog}
              fullScreen={this.props.fullScreen}
              onSignatureEnd={this.onSignatureEnd}
              releaseParcels={this.releaseParcels}
            />

            {this.renderAddParcelDialog()}
          </StyledMain>
        );
      }

      renderAddParcelDialog = () => {
        const disableParcelButton = this.props.submitting || !this.state.allowParcelSubmit;

        return (
          <Dialog
            disableBackdropClick
            fullScreen={this.props.fullScreen}
            open={this.state.parcelIsOpen}
            onClose={this.toggleParcelDialog}
            aria-labelledby="add-new-parcel"
            classes={{
              paper: 'form-dialog',
            }}
          >
            <DialogTitle id="add-new-parcel">
              <h3 style={{ textAlign: 'center', margin: 0 }}>Add Parcel</h3>
            </DialogTitle>
            <DialogContent>
              <AddParcelForm
                formName="add_parcel"
                parcelUID={this.state.newParcelUID}
                onSubmit={this.addParcel}
                allowParcelSubmit={this.allowParcelSubmit}
                showPropertySelector
              />
            </DialogContent>
            <DialogActions style={{ display: 'block', padding: '0 10px' }}>
              <FlatButton
                onClick={this.toggleParcelDialog}
                id="close-button"
                style={{ color: AccentColor(), padding: '0 15px' }}
              >
                CLOSE
              </FlatButton>
              <FlatButton
                onClick={() => this.props.submit('add_parcel')}
                disabled={disableParcelButton}
                id="submit-button"
                style={{
                  color: 'white',
                  padding: '0 15px',
                  backgroundColor: disableParcelButton ? colors.LIGHT_GRAY : AccentColor(),
                }}
              >
                SAVE
              </FlatButton>
            </DialogActions>
          </Dialog>
        );
      };

      _renderTableView = ({ parcels, tabs }) => (
        <MediaQuery query="(min-device-width: 750px)">
          <TabbedTable
            setRef={this.setRef}
            groupRowsBy="property_name"
            tabs={tabs}
            columns={this.columns}
            data={parcels}
            loadMoreData={this.fetchParcels}
            isLoading={this.props.fetchingParcels}
            filtersActive={this.state.filtersActive}
            onRowClick={data => {
              this.openParcelDetails(data.original_id);
            }}
            onColumnClick={data => {
              this.handleSort(data.key, data.order);
            }}
          />
        </MediaQuery>
      );

      _renderMobileView = ({ parcels, tabs, currentTab, tabChange }) => (
        <MediaQuery query="(max-device-width: 750px)">
          <MobileTable
            groupRowsBy="property_name"
            data={parcels}
            tabs={tabs}
            tabIndex={currentTab}
            tabChange={tabChange}
            filtersActive={this.state.filtersActive}
            columns={this.columns}
            tag="status"
            tagType="parcels"
            stickyHeaderTop={this.state.filters.search ? '137px' : '107px'}
            fieldsAboveFold={[
              {
                title: 'Full Name',
                key: 'recipient_full_name',
              },
              {
                title: 'UUID',
                key: 'uuid',
              },
            ]}
            fieldsBelowFold={[
              {
                title: 'Received On',
                key: 'received_at',
              },
              {
                title: 'Picked up on',
                key: 'released_at',
              },
            ]}
            onRowClick={data => {
              this.openParcelDetails(data.id);
            }}
          />
        </MediaQuery>
      );

      renderMultiselect = () => {
        return (
          <MultiSelectExtended
            onChange={this.onPropertySelect}
            multiple
            name="property_select"
            hintText="Select properties to filter parcels"
            data={this.props.properties}
            menuStyle={{ fontSize: '14px' }}
            textFieldStyle={{ padding: 0 }}
            style={{ fontSize: '14px' }}
            minHeight={'32px'}
            fullWidth
            fireOnChangeIfBlank
            withResetSelectAllButtons
            value={this.state.selectedPropertiesMultiSelect}
          />
        );
      };

      renderToggle = () => {
        return (
          <Toggle
            label={'Show All'}
            labelPosition="right"
            style={{ marginTop: '10px' }}
            onToggle={this.toggleAllParcels}
          />
        );
      };
    }
  )
);
